/**
 * Map an internal report status to the calm, plain-language wording the valuer sees.
 * The valuer only ever needs to know: it's being reviewed, or it's reviewed.
 */
export type StatusTone = 'reviewing' | 'done' | 'neutral' | 'attention';

export interface PlainStatus {
  label: string;
  tone: StatusTone;
  glyph: string;
}

export function plainStatus(status: string): PlainStatus {
  if (status === 'done') return { label: 'Reviewed', tone: 'done', glyph: '✓' };
  // Phase 7: the valuer needs to act - distinct from the passive "being reviewed" wording.
  if (status === 'changes_requested') return { label: 'Changes requested', tone: 'attention', glyph: '!' };
  // uploaded | queued | checking | checked | reviewing | error — all "in progress" to the valuer.
  return { label: 'Received — being reviewed', tone: 'reviewing', glyph: '•' };
}

const dateFmt = new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });

export function formatDate(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : dateFmt.format(d);
}
